import React from 'react';
const SvgIwmThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg id="iwm-thumbnail_svg__Layer_1" data-name="Layer 1" viewBox="0 0 78 94" width="1em" height="1em" {...props}>
      <defs>
        <radialGradient
          id="iwm-thumbnail_svg__radial-gradient"
          cx={48.381}
          cy={36.003}
          r={16.753}
          gradientTransform="matrix(1 0 0 6 0 -180.013)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#9bcae4" />
          <stop offset={0.076} stopColor="#9bcae4" />
          <stop offset={0.284} stopColor="#87b5d3" />
          <stop offset={0.295} stopColor="#86b4d2" />
          <stop offset={0.603} stopColor="#5f8daf" />
          <stop offset={0.848} stopColor="#47759a" />
          <stop offset={1} stopColor="#3e6c92" />
        </radialGradient>
        <radialGradient
          id="iwm-thumbnail_svg__radial-gradient-2"
          cx={40.231}
          cy={38.844}
          r={11.629}
          gradientTransform="matrix(1 0 0 3 0 -77.688)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#aae3ff" />
          <stop offset={0.186} stopColor="#83b8d8" />
          <stop offset={0.444} stopColor="#5181a6" />
          <stop offset={0.569} stopColor="#3e6c92" />
          <stop offset={0.857} stopColor="#7baac8" />
          <stop offset={1} stopColor="#9bcae4" />
        </radialGradient>
        <radialGradient
          id="iwm-thumbnail_svg__radial-gradient-3"
          cx={48.53}
          cy={40.47}
          r={19.224}
          gradientTransform="rotate(-95.2 30.052 60.705) scale(1 2)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#358cca" />
          <stop offset={0.034} stopColor="#358cca" />
          <stop offset={0.169} stopColor="#2d89c9" />
          <stop offset={0.365} stopColor="#2787c8" />
          <stop offset={0.691} stopColor="#0e74b5" />
          <stop offset={0.942} stopColor="#0069aa" />
          <stop offset={0.968} stopColor="#0069a3" />
          <stop offset={1} stopColor="#006994" />
        </radialGradient>
        <radialGradient
          id="iwm-thumbnail_svg__radial-gradient-4"
          cx={48.522}
          cy={43.768}
          r={17.211}
          gradientTransform="rotate(18.7 314.343 87.536) scale(1 3)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#005baa" />
          <stop offset={0.503} stopColor="#2787c8" />
          <stop offset={1} stopColor="#2787c8" />
        </radialGradient>
        <radialGradient
          id="iwm-thumbnail_svg__radial-gradient-5"
          cx={60.125}
          cy={60.819}
          r={2.843}
          gradientTransform="matrix(1 0 0 3 0 -121.639)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#669dd2" />
          <stop offset={0.184} stopColor="#669dd2" />
          <stop offset={0.995} stopColor="#2a5a72" />
          <stop offset={1} stopColor="#2a5a72" />
        </radialGradient>
        <style>{'.iwm-thumbnail_svg__cls-2{fill:#fff}.iwm-thumbnail_svg__cls-11{fill:#61aadb}'}</style>
      </defs>
      <g id="iwm-thumbnail_svg__assets">
        <path d="M11 3v94h78V23H69V3z" transform="translate(-11 -3)" fill="#257fbc" />
        <path className="iwm-thumbnail_svg__cls-2" d="M15 8h54v15h16v50H15z" transform="translate(-11 -3)" />
        <path d="M69 3l20 20H69z" transform="translate(-11 -3)" fill="#2787c8" />
        <path
          d="M69 23h20v20z"
          transform="translate(-11 -3)"
          style={{
            isolation: 'isolate'
          }}
          fill="#1b3f63"
          opacity={0.2}
        />
        <g>
          <path
            d="M36.392 64.527v-7.129a7.42 7.42 0 003.906-1.012 4.78 4.78 0 001.486-1.522c1.015-1.648 1.06-3.789 1.095-5.509.006-.3.012-.585.022-.853.105-2.63.305-17.218.305-21.138 0-3.017-.472-3.118-4.772-3.118H37.7c-.757 0-.843-.397-.851-.519l-.054-6.635c0-.969 1.326-1.074 1.896-1.074.158 0 .26.009.261.009h20.925c.263 0 .595.052.68.296a.316.316 0 01.017.112l-.001.014v.01l.094 6.254-.768 1.537h-2.96c-2.916 0-3.148 1.381-3.148 3.186 0 .211-.013 1.08-.033 2.397-.059 3.894-.169 11.14-.169 16.279q0 1.134-.004 2.12c-.016 5.016-.024 7.306 1.049 8.382.557.559 1.396.787 2.897.787h2.457c.099.862.14 4.232.145 6.52a2.855 2.855 0 01-.522.294 7.207 7.207 0 01-1.03.312z"
            transform="translate(-11 -3)"
            fill="#28c"
          />
          <path
            d="M36 17.094l.053 6.632.001.016c.127-.754.705-.804 2.56-.804 3.815 0 5.794-.09 5.794 4.46 0 4.249-.28 23.504-2.808 27.352a4.538 4.538 0 01-1.42 1.453c4.806-2.403 6.837-17.932 9.463-27.869 1.3-4.923 5.603-8.903 11.118-12.081-.065-.19-.268-.442-.884-.442H38.392s-.108-.01-.279-.01c-.63 0-2.113.125-2.113 1.293"
            transform="translate(-11 -3)"
            fill="url(#iwm-thumbnail_svg__radial-gradient)"
          />
          <path
            d="M38.614 22.938c-1.855 0-2.433.05-2.56.804.007.106.09.72 1.067.72 4.95 0 5.868-.08 5.868 2.903 0 3.778-.197 18.44-.304 21.129-.072 1.802.072 4.377-1.085 6.256 2.528-3.848 2.808-23.103 2.808-27.353 0-4.376-1.833-4.459-5.369-4.459h-.425"
            transform="translate(-11 -3)"
            fill="url(#iwm-thumbnail_svg__radial-gradient-2)"
          />
          <path
            d="M49.643 28.334c-2.626 9.937-4.657 25.466-9.462 27.87a7.291 7.291 0 01-4.006.98v7.504c1.497-.633 8.29-3.774 11.091-9.783 3.365-7.215.628-21.22 5.478-28.99 1.518-2.43 2.516-2.937 5.143-2.955.803-.005 1.828-.163 2.983-.168l.014-.027-.094-6.31a.513.513 0 00-.029-.202c-5.515 3.178-9.817 7.158-11.118 12.081"
            transform="translate(-11 -3)"
            fill="url(#iwm-thumbnail_svg__radial-gradient-3)"
          />
          <path
            d="M57.887 22.809c-2.205 0-3.625.675-5.143 3.106-4.85 7.77-2.113 21.775-5.478 28.99-2.802 6.01-9.594 9.15-11.091 9.783v.056h23.08s-.18-7.54 1.567-7.85h-2.64c-4.084 0-4.376-1.58-4.376-11.071 0-6.913.202-17.56.202-18.387 0-1.801.245-2.97 2.932-2.97h3.093l.837-1.674c-1.155.005-2.18.017-2.983.017"
            transform="translate(-11 -3)"
            fill="url(#iwm-thumbnail_svg__radial-gradient-4)"
          />
          <path
            d="M59.256 64.744a7.603 7.603 0 001.092-.33A2.788 2.788 0 0061 64.03s-.009-6.485-.178-7.134c-1.746.309-1.566 7.85-1.566 7.85"
            transform="translate(-11 -3)"
            fill="url(#iwm-thumbnail_svg__radial-gradient-5)"
          />
          <path
            className="iwm-thumbnail_svg__cls-11"
            d="M60.822 56.895s-.031.009-.088.03a.807.807 0 00-.215.14 1.32 1.32 0 00-.244.313 2.96 2.96 0 00-.214.472 6.042 6.042 0 00-.175.592c-.053.213-.097.442-.14.678s-.077.483-.113.734c-.034.251-.063.507-.088.763-.028.257-.052.513-.072.766-.02.254-.042.503-.058.744l-.046.698-.038.625-.075 1.294s-.014-.13-.03-.356a19.549 19.549 0 01-.044-.94 18.962 18.962 0 01-.006-.63c0-.223.002-.459.012-.702s.017-.496.036-.751c.017-.256.038-.515.064-.774.028-.26.06-.518.098-.772.037-.254.086-.503.136-.743.05-.24.112-.47.178-.686a4.7 4.7 0 01.224-.596 2.61 2.61 0 01.269-.47 1.269 1.269 0 01.294-.299.76.76 0 01.243-.114c.06-.012.092-.016.092-.016M60.761 16.253l-.397.24c-.259.157-.634.393-1.11.697a39.136 39.136 0 00-2.165 1.514c-.168.124-.336.257-.51.392s-.348.279-.53.423c-.176.148-.36.297-.542.456a23.365 23.365 0 00-2.23 2.172 18.277 18.277 0 00-2.06 2.783 13.299 13.299 0 00-1.446 3.392l-.465 1.86c-.153.624-.293 1.253-.44 1.88-.15.627-.288 1.258-.431 1.884l-.42 1.872-.814 3.642c-.273 1.18-.536 2.32-.813 3.395l-.2.796-.098.39-.103.38-.398 1.459-.095.347-.101.337-.196.65-.188.616-.194.578-.182.542c-.06.174-.112.343-.175.502l-.33.876-.141.375-.14.324-.223.512-.184.425.171-.43.207-.518.13-.328.134-.377.309-.883c.059-.16.107-.33.163-.504l.169-.545.18-.58.174-.62.185-.653.097-.338.09-.347q.18-.702.377-1.46l.098-.383.092-.39.189-.798c.262-1.077.505-2.22.777-3.4l.798-3.644.41-1.874c.141-.628.275-1.26.424-1.888.15-.629.294-1.26.45-1.883l.475-1.861a13.534 13.534 0 011.485-3.445 17.339 17.339 0 012.114-2.794 23.489 23.489 0 012.275-2.157 28.384 28.384 0 012.108-1.6 39.157 39.157 0 011.707-1.116c.482-.295.866-.517 1.129-.667l.404-.228"
            transform="translate(-11 -3)"
          />
          <path
            className="iwm-thumbnail_svg__cls-11"
            d="M36.175 64.688s.195-.083.553-.253a27.885 27.885 0 003.797-2.19 25.457 25.457 0 002.706-2.147 18.329 18.329 0 002.688-3.06 14.8 14.8 0 001.123-1.917l.123-.257c.045-.092.088-.174.127-.26.081-.17.156-.349.226-.528.14-.359.26-.73.366-1.11a30.845 30.845 0 00.834-4.798c.18-1.654.302-3.342.426-5.03.127-1.689.249-3.379.404-5.04.155-1.661.342-3.295.603-4.865a28.784 28.784 0 011.065-4.463 12.184 12.184 0 011.866-3.661 6.534 6.534 0 011.318-1.277 5.499 5.499 0 011.473-.75 5.896 5.896 0 011.424-.283c.112-.01.222-.012.33-.018.106-.002.212-.002.314-.002l.585.005 2.329.025-2.329.024-.585.005-.313.008c-.106.008-.215.01-.325.023a5.803 5.803 0 00-1.4.302 5.387 5.387 0 00-1.431.76 6.56 6.56 0 00-1.277 1.267 12.026 12.026 0 00-1.803 3.63 30.299 30.299 0 00-1.021 4.441c-.254 1.564-.435 3.192-.584 4.85-.15 1.66-.266 3.348-.386 5.037a133.622 133.622 0 01-.442 5.039c-.094.83-.202 1.651-.338 2.46a22.437 22.437 0 01-.52 2.373c-.108.384-.232.762-.376 1.13a8.268 8.268 0 01-.234.541c-.041.09-.088.177-.128.258l-.126.26a15.015 15.015 0 01-1.159 1.932 18.502 18.502 0 01-2.747 3.06 22.86 22.86 0 01-2.75 2.119 27.713 27.713 0 01-2.3 1.366c-.655.348-1.184.592-1.546.754-.363.161-.56.24-.56.24"
            transform="translate(-11 -3)"
          />
        </g>
        <g>
          <path
            className="iwm-thumbnail_svg__cls-2"
            d="M30.267 78.303h2.646V93h-2.646zM53.176 78.303L50.697 93h-3.716l-2.477-12.367L42.026 93H38.29l-2.54-14.697h2.708l1.848 12.45 2.54-12.45h3.401l2.583 12.45 1.784-12.45zM70.248 78.303V93h-2.541V82.607L64.6 92.98V93h-2.856l-3.191-10.834V93H56.2V78.303h3.423L63.235 90.9l3.716-12.555-.02-.042z"
            transform="translate(-11 -3)"
          />
        </g>
      </g>
    </svg>
  );
});
export default SvgIwmThumbnail;
SvgIwmThumbnail.iconName = 'iwm-thumbnail';
SvgIwmThumbnail.displayName = 'SvgIwmThumbnail';
